import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "persons-view-container"
}
const _hoisted_2 = {
  key: 0,
  class: "persons-view__available-tickets"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-info me-2 mb-1 persons-view__available-tickets-icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_4 = { class: "persons-view__available-ticket-counter" }
const _hoisted_5 = { class: "row gy-4 justify-content-center" }
const _hoisted_6 = { class: "col-md-3 col-6" }
const _hoisted_7 = {
  key: 1,
  class: "service-block"
}
const _hoisted_8 = { class: "service-block__title" }
const _hoisted_9 = { class: "service-item-wrapper" }
const _hoisted_10 = { class: "service-item" }
const _hoisted_11 = { class: "service-item__title" }
const _hoisted_12 = { class: "service-item__services" }
const _hoisted_13 = { class: "service-item__service" }
const _hoisted_14 = { class: "form-check form-check--primary d-flex align-items-center" }
const _hoisted_15 = ["value", "onUpdate:modelValue", "onChange"]
const _hoisted_16 = { class: "form-check-label pt-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", { class: "ms-1 btn-no-styling" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-info" })
], -1)
const _hoisted_18 = { class: "service-item__price" }
const _hoisted_19 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PriceGroupItem = _resolveComponent("PriceGroupItem")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_Error = _resolveComponent("Error")!

  return (!_ctx.loadingServices.error && !_ctx.loadingPriceGroups.error && !_ctx.loadingPrice.error)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.availableTickets)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.availableTickets), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.translate('shop.ticket.configuration.available')), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticketPriceGroups, (priceGroup) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(), _createBlock(_component_PriceGroupItem, {
                title: priceGroup.name,
                "is-available": _ctx.ticketPrices[priceGroup.id] !== undefined,
                key: priceGroup.id,
                id: priceGroup.id,
                price: _ctx.ticketPrices[priceGroup?.id]?.price,
                description: priceGroup.description,
                imgName: priceGroup.img,
                counter: _ctx.ticketCounter[priceGroup.id] ? _ctx.ticketCounter[priceGroup.id] : 0,
                onChangeCounter: ($event: any) => (_ctx.changeTicketCounter(priceGroup.id, $event)),
                maxCounter: _ctx.getMaxCounter(_ctx.ticketCounter[priceGroup.id])
              }, null, 8, ["title", "is-available", "id", "price", "description", "imgName", "counter", "onChangeCounter", "maxCounter"]))
            ]))
          }), 256))
        ]),
        (_ctx.ticketCounterSum > 0 && _ctx.ticketServices.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.translate('shop.ticket.configuration.services-title')), 1),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticketConfigurations, (item) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.priceGroupName?.singularName) + " " + _toDisplayString(item.index), 1),
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticketServices, (service) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("label", _hoisted_14, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              class: "form-check-input",
                              value: service.id,
                              "onUpdate:modelValue": ($event: any) => ((item.service) = $event),
                              onChange: ($event: any) => (_ctx.onChangeTicketServices(item))
                            }, null, 40, _hoisted_15), [
                              [_vModelRadio, item.service]
                            ]),
                            _createElementVNode("span", _hoisted_16, [
                              _createTextVNode(_toDisplayString(service.name) + " ", 1),
                              (service.infoBubble)
                                ? (_openBlock(), _createBlock(_component_Popper, {
                                    key: 0,
                                    arrow: ""
                                  }, {
                                    content: _withCtx(() => [
                                      _createElementVNode("div", null, _toDisplayString(service.infoBubble), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _hoisted_17
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 256))
                    ]),
                    _createElementVNode("div", _hoisted_18, " CHF " + _toDisplayString(item.priceSum), 1)
                  ]))
                }), 256))
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
        _createVNode(_component_Error, {
          errorMessage: _ctx.loadingServices.error ? _ctx.loadingServices.errorMessage : _ctx.loadingPriceGroups.error ? _ctx.loadingPriceGroups.errorMessage : _ctx.loadingPrice.error ? _ctx.loadingPrice.errorMessage : ''
        }, null, 8, ["errorMessage"])
      ]))
}